export class PropertyIdCode {
    constructor(
        public propertyCode: string = null,
        public customCode: string = null,
        public propertyId: number = null
    ) { }
}